const fuwuinfo = {
  path: '/fuwuinfo',
  name: 'fuwuinfo',
  component: resolve => require(['@/views/fuwu-info/fuwu-info.vue'], resolve),
  children:[
    {
      path: 'index',//视频列表
      meta:{
        tabBar: false,
      },
      component: resolve => require(['@/views/fuwu-info/index.vue'], resolve),
      children:[

      ]
    },
    {
      path: 'details',  // 微视视频详情
      meta:{
        tabBar: false,
      },
      component: resolve => require(['@/views/fuwu-info/details.vue'], resolve),
      children:[

      ]
    }
  ]
};

export default fuwuinfo;
